var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"presentation-sidebar layout-grid row-min-content dark-mode",class:[_vm.columnClass]},[_c('ResizeBar',{attrs:{"column":_vm.resizeOption}}),_c('div',{staticClass:"no-padding"},[_c('HandsRaised'),_c('Attendees')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }